import { render, staticRenderFns } from "./VSummary.vue?vue&type=template&id=933fde8c"
import script from "./VSummary.vue?vue&type=script&lang=js"
export * from "./VSummary.vue?vue&type=script&lang=js"
import style0 from "./VSummary.vue?vue&type=style&index=0&id=933fde8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports